<!-- css -->
<style type="text/css" scoped>
.charts {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.charts-back {
  position: absolute;
  left: 8px;
  width: 40px;
}

.header {
  height: 48px;
  background-color: #FAFAFA;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tab {
  align-self: center;
  width: 100%;
  background-color: #FAFAFA;
}

.tab-item {
  width: 60px;
  /*margin: 0px 5px 0px 5px;*/
  font-size: 14px;
  color: #333333;
}

.container {
  flex-grow: 1;
  margin-top: 2px;
}

.charts-toolbar {
  height: 40px;
  z-index: 1000;
  width: 100%;
  position: absolute;
  bottom: 0px;
  left: 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 32px;
}

.mint-navbar .mint-tab-item.is-selected {
  border-bottom: 3px solid #EEB862;
  color: #EEB862;
  margin-bottom: -3px;
}

.chart-next {
  position: absolute;
  width: 24px;
  bottom: 10px;
  left: 24px;
}

.chart-last {
  position: absolute;
  width: 24px;
  top: 85px;
  left: 24px;
}

.switch-model {
  position: absolute;
  height: 32px;
  width: 32px;
  right: 16px;
  bottom: 16px;
}

.border-left {
  border-left: 1px solid #CCCCCC;
}

.border-right {
  border-right: 1px solid #CCCCCC;
}

.border-top {
  border-top: 1px solid #CCCCCC;
}

.border-bottom {
  border-bottom: 1px solid #CCCCCC;
}

.header-border-right {
  border-right: 1px solid;
  border-color: rgba(0, 0, 0, 0.1);
}

.header-border-left {
  border-left: 1px solid;
  border-color: rgba(0, 0, 0, 0.1);
}

.table-header {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.table-header-item {
  flex: 1;
  flex-grow: 1;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #EEB862;
  overflow: hidden;
}

.table-header-item span {
  color: #FFFFFF;
}

.table-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.table-row-item {
  height: 40px;
  flex: 1;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.table-row-item span {
  font-size: 14px;
  color: #333333;
}

.table-content {
  height: 100%;
  overflow: auto;
}

.table {
  margin-top: 10px;
}

</style>
<!-- html -->
<template>
  <div class="charts">
    <!-- tab -->
    <div class="header">
      <img class="charts-back" src="../../assets/header_back.png" @click="handleBack" v-show="showBackArrow">
      <mt-navbar v-model="selected" class="tab">
        <mt-tab-item class="tab-item" id="1">成交价格</mt-tab-item>
        <mt-tab-item class="tab-item" id="2">成交量</mt-tab-item>
        <mt-tab-item class="tab-item" id="3">户型分布</mt-tab-item>
      </mt-navbar>
    </div>
    <!-- container -->
    <div class="container">
      <!-- tab-container -->
      <mt-tab-container v-model="selected" :swipeable="true">
        <mt-tab-container-item id="1">
          <!-- chart -->
          <div v-show="isShowChart" class="container-item" id="priceChart"></div>
          <!-- table -->
          <div v-show="!isShowChart" class="container-item table">
            <!-- header -->
            <div class="table-header">
              <div class="table-header-item header-border-right">
                <span>日期</span>
              </div>
              <div class="table-header-item">
                <span>北京</span>
              </div>
              <div class="table-header-item header-border-left" v-show="!onlyShowBJ">
                <span>{{this.$route.params.name}}</span>
              </div>
            </div>
            <!-- row -->
            <div class="table-content">
              <div class="table-row" v-for="(item ,index) in price">
                <div class="table-row-item border-right border-bottom">
                  <span>{{item.date}}</span>
                </div>
                <div class="table-row-item border-right border-bottom">
                  <span>{{item.bjPrice}}</span>
                </div>
                <div class="table-row-item border-bottom" v-show="!onlyShowBJ">
                  <span>{{item.price}}</span>
                </div>
              </div>
            </div>
          </div>
        </mt-tab-container-item>
        <mt-tab-container-item id="2">
          <!-- chart -->
          <div v-show="isShowChart" class="container-item" id="countChart"></div>
          <!-- table -->
          <div v-show="!isShowChart" class="container-item table">
            <!-- header -->
            <div class="table-header">
              <div class="table-header-item header-border-right">
                <span>日期</span>
              </div>
              <div class="table-header-item">
                <span>北京</span>
              </div>
              <div class="table-header-item header-border-left" v-show="!onlyShowBJ">
                <span>{{this.$route.params.name}}</span>
              </div>
            </div>
            <!-- row -->
            <div class="table-content">
              <div class="table-row" v-for="(item ,index) in count">
                <div class="table-row-item border-right border-bottom">
                  <span>{{item.date}}</span>
                </div>
                <div class="table-row-item border-right border-bottom">
                  <span>{{item.bjCount}}</span>
                </div>
                <div class="table-row-item border-bottom" v-show="!onlyShowBJ">
                  <span>{{item.count}}</span>
                </div>
              </div>
            </div>
          </div>
        </mt-tab-container-item>
        <mt-tab-container-item id="3">
          <!-- chart -->
          <div v-show="isShowChart" class="container-item" id="modelChart"></div>
          <!-- table -->
          <div v-show="!isShowChart" class="container-item table">
            <!-- header -->
            <div class="table-header">
              <div class="table-header-item header-border-right">
                <span>户型</span>
              </div>
              <div class="table-header-item">
                <span>北京</span>
              </div>
              <div class="table-header-item header-border-left" v-show="!onlyShowBJ">
                <span>{{this.$route.params.name}}</span>
              </div>
            </div>
            <!-- row -->
            <div class="table-content">
              <div class="table-row" v-for="(item ,index) in model">
                <div class="table-row-item border-right border-bottom">
                  <span>{{item.type}}</span>
                </div>
                <div class="table-row-item border-right border-bottom">
                  <span>{{item.bjCount}}</span>
                </div>
                <div class="table-row-item border-bottom" v-show="!onlyShowBJ">
                  <span>{{item.count}}</span>
                </div>
              </div>
            </div>
          </div>
        </mt-tab-container-item>
      </mt-tab-container>
    </div>
    <!-- next -->
    <img v-show="showToolBar && isShowChart" class="chart-next" src="../../assets/chart_next.png" @click="handleNext">
    <!-- last -->
    <img v-show="showToolBar && isShowChart" class="chart-last" src="../../assets/chart_last.png" @click="handleLast">
    <!-- switch -->
    <img class="switch-model" :src="switchImg" @click.stop="switchModelHandler">
  </div>
</template>
<!-- javascript -->
<script type="text/javascript">
import echarts from 'echarts'
import * as Price from '../chartjs/PriceChart.js'
import * as Count from '../chartjs/CountChart.js'
import * as Model from '../chartjs/ModelChart.js'
import * as chart from './NIChart.js'
import Tool from '../../common/tool'
import Storage from '../../common/storage'
import {
  Toast,
  MessageBox
} from 'mint-ui'
export default {
  name: 'charts',
  data: function(argument) {
    return {
      price: [],

      model: [],

      count: [],

      selected: '1',

      priceChart: null,

      countChart: null,

      modelChart: null,

      showBackArrow: false,

      data: null,

      showToolBar: false,

      switchImg: require('../../assets/table_switch.png'),

      isChart: true,

      isShowChart: true,

      onlyShowBJ: false
    }
  },
  watch: {
    selected: function(newVal, oldVal) {
      if (newVal === '1') {
        this.$nextTick(function(argument) {
          this.loadChartData('price')
        })
      } else if (newVal === '2') {
        this.$nextTick(function(argument) {
          this.loadChartData('count')
        })
      } else if (newVal === '3') {
        this.$nextTick(function(argument) {
          this.loadChartData('model')
        })
      }
    },
    data: function(newVal, oldVal) {
      this.formatedData(newVal)
    }
  },
  mounted: function(argument) {
    if (this.$route.params.from === 'search') {
      this.data = this.$route.params.data
    }
    this.updateUI()
    this.loadChartData('price')
  },
  methods: {
    // 格式化数据
    formatedData: function(data) {
      if (parseInt(Tool.query('type')) === 3) {
        this.onlyShowBJ = true
        let model = []
        // 户型
        let unkownCount = 0
        for (let k = 0, length = data.bedroom.length; k < length; k++) {
          let type = this.localization(data.bedroom[k].bedroom)
          if (type === '未知') {
            unkownCount = unkownCount + parseInt(data.bedroom[k].count)
            continue
          }
          let bjCount = data.bedroom[k].count
          model.push({
            type: type,
            bjCount: bjCount
          })
        }

        model.push({
          type: '未知',
          bjCount: unkownCount
        })
        this.model = model

        // 成交价格
        let prices = []
        for (let key in data.price) {
          let date = key
          let bjPrice = data.price[key]

          prices.push({
            date: date,
            bjPrice: bjPrice
          })
        }

        this.price = prices.reverse()

        // 成交量
        let counts = []
        for (let key in data.count) {
          let date = key
          let bcount = data.count[key]

          counts.push({
            date: date,
            bjCount: bcount
          })
        }

        this.count = counts.reverse()
      } else {
        console.log('------------------------')
        console.log(data)
        this.onlyShowBJ = false
        let model = []
        // 户型
        let unkownCount = 0
        let bjUnkownCount = 0
        for (let k = 0, length = data.bj_bedroom.length; k < length; k++) {
          let type = this.localization(data.bj_bedroom[k].bedroom)
          if (type === '未知') {
            if (data.bj_bedroom !== undefined && data.bj_bedroom[k] !== undefined && data.bj_bedroom[k].count !== undefined) {
              bjUnkownCount = bjUnkownCount + parseInt(data.bj_bedroom[k].count)
            }

            if (data.bedroom !== undefined && data.bedroom[k] !== undefined && data.bedroom[k].count !== undefined) {
              unkownCount = unkownCount + parseInt(data.bedroom[k].count)
            }
            continue
          }
          let bjCount = data.bj_bedroom[k].count
          let count = 0

          if (data.bedroom !== undefined && data.bedroom[k] !== undefined && data.bedroom[k].count !== undefined) {
            count = data.bedroom[k].count
          }

          model.push({
            type: type,
            bjCount: bjCount,
            count: count
          })
        }
        model.push({
          type: '未知',
          bjCount: bjUnkownCount,
          count: unkownCount
        })
        this.model = model
        // 成交价格
        let prices = []
        for (let key in data.bj_price) {
          let date = key
          let bjPrice = data.bj_price[key]
          let price = data.price[key] === undefined ? 0 : data.price[key]

          prices.push({
            date: date,
            bjPrice: bjPrice,
            price: price
          })
        }

        this.price = prices.reverse()

        // 成交量
        let counts = []
        for (let key in data.bj_count) {
          let date = key
          let bcount = data.bj_count[key]
          let count = 0

          if (data.count !== undefined && data.count[key] !== undefined) {
            count = data.count[key]
          }

          counts.push({
            date: date,
            bjCount: bcount,
            count: count
          })
        }

        this.count = counts.reverse()
      }
    },
    localization: function(item) {
      if (parseInt(item) === 1) {
        return '一居室'
      }

      if (parseInt(item) === 2) {
        return '两居室'
      }
      if (parseInt(item) === 3) {
        return '三居室'
      }
      if (parseInt(item) === 4) {
        return '四居室'
      }
      if (parseInt(item) === 5) {
        return '五居室'
      }
      if (parseInt(item) === 6) {
        return '六居室'
      }
      if (parseInt(item) === 7) {
        return '七居室'
      }
      if (parseInt(item) === 8) {
        return '八居室'
      }
      if (parseInt(item) === 9) {
        return '九居室'
      }

      return '未知'
    },
    // switchModelHandler
    switchModelHandler: function(evt) {
      if (this.isChart) {
        this.isChart = false
        this.isShowChart = false
        this.switchImg = require('../../assets/chart_switch.png')
      } else {
        this.isChart = true
        this.isShowChart = true
        this.switchImg = require('../../assets/table_switch.png')

        if (this.selected === '1') {
          this.$nextTick(function(argument) {
            this.loadChartData('price')
          })
        } else if (this.selected === '2') {
          this.$nextTick(function(argument) {
            this.loadChartData('count')
          })
        } else if (this.selected === '3') {
          this.$nextTick(function(argument) {
            this.loadChartData('model')
          })
        }
      }
    },
    // handleNext
    handleNext: function(argument) {
      if (parseInt(this.selected) === 1) {
        let option = Price.nextChart(this.data, this)
        this.initPriceChart(option)
      } else if (parseInt(this.selected) === 2) {
        let option = Count.nextChart(this.data, this)
        this.initCountChart(option)
      }
    },
    // handleLast
    handleLast: function(argument) {
      if (parseInt(this.selected) === 1) {
        let option = Price.lastChart(this.data, this)
        this.initPriceChart(option)
      } else if (parseInt(this.selected) === 2) {
        let option = Count.lastChart(this.data, this)
        this.initCountChart(option)
      }
    },
    // 加载数据
    loadChartData: function(chartType) {
      if (!this.isChart) {
        return
      }
      let _this = this
      if (this.data === null) { // 加载网络数据
        chart.loadChartData(this.$route.params.name, function(data, type) {
          // 更新金币数量
          if (data !== null && data.coin !== undefined && data.coin) {
            Storage.setItem('coin', data.coin)
          }
          // 无数据提示
          if (data === null || data.price === undefined) {
            MessageBox.alert('抱歉，暂无成交数据', '提示').then(action => {
              _this.$router.go(-1)
            })
          } else { // 有网络数据
            _this.data = data
            if (chartType === 'price') {
              _this.initPriceChart(Price.creatPriceOptions(data, _this))
            } else if (chartType === 'count') {
              _this.initCountChart(Count.creatOption(data, _this))
            } else if (chartType === 'model') {
              _this.initModelChart(Model.creatOption(data, _this))
            }
          }
        })
      } else { // 加载缓存数据
        if (chartType === 'price') {
          _this.initPriceChart(Price.creatPriceOptions(_this.data, _this))
        } else if (chartType === 'count') {
          _this.initCountChart(Count.creatOption(_this.data, _this))
        } else if (chartType === 'model') {
          _this.initModelChart(Model.creatOption(_this.data, _this))
        }
      }
    },
    // 返回上级菜单
    handleBack: function(argument) {
      this.$router.go(-1)
    },
    // 户型分布
    initModelChart: function(option) {
      if (this.modelChart && !this.modelChart.isDisposed()) {
        this.modelChart.dispose()
      }
      this.modelChart = echarts.init(document.getElementById('modelChart'))
      this.modelChart.setOption(option, true)
      window.onresize = this.modelChart.resize
      // 隐藏tool bar
      this.showToolBar = false
    },
    // 成交量
    initCountChart: function(option) {
      if (option === null) {
        Toast({
          message: '没有了啦 ^_^',
          position: 'middle',
          duration: 1000
        })
        return
      }
      if (this.countChart && !this.countChart.isDisposed()) {
        this.countChart.dispose()
      }
      this.countChart = echarts.init(document.getElementById('countChart'))
      this.countChart.setOption(option, true)
      window.onresize = this.countChart.resize

      // 展示toolbar
      this.showToolBar = true
    },
    // 成交价格
    initPriceChart: function(option) {
      if (option === null) {
        Toast({
          message: '没有了啦 ^_^',
          position: 'middle',
          duration: 1000
        })
        return
      }
      if (this.priceChart && !this.priceChart.isDisposed()) {
        this.priceChart.dispose()
      }
      this.priceChart = echarts.init(document.getElementById('priceChart'))
      this.priceChart.setOption(option, true)
      window.onresize = this.priceChart.resize

      // 展示tool bar
      this.showToolBar = true
    },
    // 更新UI
    updateUI: function() {
      let height = Tool.getViewPort().height
      let items = document.getElementsByClassName('container-item')
      for (var i = 0; i < items.length; i++) {
        items[i].style.height = (height - 64) + 'px'
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// NICharts.vue?2d6cf456